import { api } from "@/api/client";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
  return arr;
}

async function registerSW() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/service-worker.js");
  } catch (e) {
    console.warn("SW register failed", e);
    return null;
  }
}

export async function subscribeToPush() {
  if (!("Notification" in window) || !("serviceWorker" in navigator) || !("PushManager" in window)) {
    return { ok: false, reason: "unsupported" };
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, reason: "denied" };

  const reg = await registerSW();
  if (!reg) return { ok: false, reason: "sw-failed" };
  await navigator.serviceWorker.ready;

  let publicKey;
  try {
    const r = await api.get("/push/public-key");
    publicKey = r.data.publicKey;
  } catch {
    return { ok: false, reason: "no-key" };
  }

  try {
    const existing = await reg.pushManager.getSubscription();
    if (existing) {
      await api.post("/push/subscribe", existing.toJSON());
      return { ok: true, existing: true };
    }
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
    await api.post("/push/subscribe", sub.toJSON());
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: e?.message || "subscribe-failed" };
  }
}

export async function pushSupported() {
  return "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;
}

export function pushPermission() {
  return typeof Notification !== "undefined" ? Notification.permission : "denied";
}
